import React from 'react';
import { MultiSelect, NumberInput, Select, TextInput } from '@mantine/core';
import { Button } from '../../../components/Button';
import { AMOUNT_FILTER_OPTIONS, type AmountFilterMode } from '../monitoring-page.constants';
import type { UseMonitoringPage } from '../useMonitoringPage';
import classes from '../monitoring-page.module.scss';

type OrdersMonitoringFiltersProps = Pick<
  UseMonitoringPage,
  | 'ordersSearch'
  | 'setOrdersSearch'
  | 'ordersCompanyFilter'
  | 'setOrdersCompanyFilter'
  | 'ordersSessionFilter'
  | 'setOrdersSessionFilter'
  | 'ordersStatusFilter'
  | 'setOrdersStatusFilter'
  | 'ordersAmountFilterMode'
  | 'setOrdersAmountFilterMode'
  | 'ordersAmountExact'
  | 'setOrdersAmountExact'
  | 'ordersAmountMin'
  | 'setOrdersAmountMin'
  | 'ordersAmountMax'
  | 'setOrdersAmountMax'
  | 'ordersDateFrom'
  | 'setOrdersDateFrom'
  | 'ordersDateTo'
  | 'setOrdersDateTo'
  | 'ordersCompanyOptions'
  | 'ordersSessionOptions'
  | 'ordersStatusOptions'
  | 'clearOrdersFilters'
>;

export const OrdersMonitoringFilters: React.FC<OrdersMonitoringFiltersProps> = ({
  ordersSearch,
  setOrdersSearch,
  ordersCompanyFilter,
  setOrdersCompanyFilter,
  ordersSessionFilter,
  setOrdersSessionFilter,
  ordersStatusFilter,
  setOrdersStatusFilter,
  ordersAmountFilterMode,
  setOrdersAmountFilterMode,
  ordersAmountExact,
  setOrdersAmountExact,
  ordersAmountMin,
  setOrdersAmountMin,
  ordersAmountMax,
  setOrdersAmountMax,
  ordersDateFrom,
  setOrdersDateFrom,
  ordersDateTo,
  setOrdersDateTo,
  ordersCompanyOptions,
  ordersSessionOptions,
  ordersStatusOptions,
  clearOrdersFilters,
}) => (
  <div className={classes.filtersCard}>
    <div className={classes.filtersGrid}>
      <div className={classes.fieldStack}>
        <TextInput
          label={'חיפוש'}
          placeholder={'הזמנה / שולחן / עובד / חברה'}
          value={ordersSearch}
          onChange={(event) => setOrdersSearch(event.currentTarget.value)}
          data-testid="monitoring-orders-search"
        />
      </div>
      <div className={classes.fieldStack}>
        <MultiSelect
          label={'חברות'}
          placeholder={'בחר חברות'}
          data={ordersCompanyOptions}
          value={ordersCompanyFilter}
          onChange={setOrdersCompanyFilter}
          searchable
          clearable
          data-testid="monitoring-orders-company"
        />
      </div>
      <div className={classes.fieldStack}>
        <MultiSelect
          label={'משמרות'}
          placeholder={'בחר משמרות'}
          data={ordersSessionOptions}
          value={ordersSessionFilter}
          onChange={setOrdersSessionFilter}
          searchable
          clearable
          data-testid="monitoring-orders-session"
        />
      </div>
      <div className={classes.fieldStack}>
        <MultiSelect
          label={'סטטוס הזמנה'}
          placeholder={'בחר סטטוסים'}
          data={ordersStatusOptions}
          value={ordersStatusFilter}
          onChange={setOrdersStatusFilter}
          clearable
          data-testid="monitoring-orders-status"
        />
      </div>
      <div className={classes.fieldStack}>
        <Select
          label={'סינון סכום'}
          data={AMOUNT_FILTER_OPTIONS}
          value={ordersAmountFilterMode}
          onChange={(value) => setOrdersAmountFilterMode((value as AmountFilterMode) ?? 'all')}
          allowDeselect={false}
          data-testid="monitoring-orders-amount-mode"
        />
        {ordersAmountFilterMode === 'exact' && (
          <NumberInput
            value={ordersAmountExact}
            onChange={setOrdersAmountExact}
            placeholder={'סכום מדויק'}
            decimalScale={1}
            data-testid="monitoring-orders-amount-exact"
          />
        )}
        {ordersAmountFilterMode === 'between' && (
          <div className={classes.fieldRow}>
            <NumberInput
              value={ordersAmountMin}
              onChange={setOrdersAmountMin}
              placeholder={'מסכום'}
              decimalScale={1}
              data-testid="monitoring-orders-amount-min"
            />
            <NumberInput
              value={ordersAmountMax}
              onChange={setOrdersAmountMax}
              placeholder={'עד סכום'}
              decimalScale={1}
              data-testid="monitoring-orders-amount-max"
            />
          </div>
        )}
      </div>
      <div className={classes.fieldStack}>
        <TextInput
          label={'מתאריך פתיחה'}
          type="date"
          value={ordersDateFrom}
          onChange={(event) => setOrdersDateFrom(event.currentTarget.value)}
          data-testid="monitoring-orders-date-from"
        />
      </div>
      <div className={classes.fieldStack}>
        <TextInput
          label={'עד תאריך פתיחה'}
          type="date"
          value={ordersDateTo}
          onChange={(event) => setOrdersDateTo(event.currentTarget.value)}
          data-testid="monitoring-orders-date-to"
        />
      </div>
    </div>

    <div className={classes.filtersActions}>
      <Button variant="cancel" onClick={clearOrdersFilters} dataTestId="monitoring-orders-clear">
        {'נקה סינונים'}
      </Button>
    </div>
  </div>
);
